import type { Editor } from '@tiptap/react';

export function getLiveEditor(editor: Editor | null | undefined): Editor | null {
  return editor && !editor.isDestroyed ? editor : null;
}
